import React from "react";
import { LogOut, RefreshCcw } from "lucide-react";

const AdminHeader = ({ admin, onReload, onLogout }) => (
  <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
    <div>
      <p className="overline mb-2">Admin · {admin.email}</p>
      <h1 className="font-display uppercase text-3xl md:text-4xl tracking-tight font-bold leading-[1]">
        Pritch Console
      </h1>
    </div>
    <div className="flex gap-2">
      <button
        type="button"
        onClick={onReload}
        className="btn-secondary !px-4 !py-2"
        data-testid="admin-refresh"
      >
        <RefreshCcw size={14} className="mr-2" /> Refresh
      </button>
      <button
        type="button"
        onClick={onLogout}
        className="btn-primary !px-4 !py-2"
        data-testid="admin-logout"
      >
        <LogOut size={14} className="mr-2" /> Sign out
      </button>
    </div>
  </div>
);

export default AdminHeader;
